module.exports = __webpack_public_path__ + "static/media/logo-dark.4173e696.svg";


//////////////////
// WEBPACK FOOTER
// ./src/custom/livres/img/logo-dark.svg
// module id = 166
// module chunks = 0